import React from 'react';

const ReposIpfsShipyardIpfsUiStyleGuide = () => (
  <div id='content' className='pt3 pr4 pl4 w-100'>
    <h1><span className='nav-category'>Repo:</span> ipfs-shipyard/ipfs-ui-style-guide</h1>

    <p>This repo contains the source code for a basic UI style guide for achieving a consistent IPFS "look and feel". Long-term plans for this repo include extending it into a more useful set of atomic components that can be used both within the core team and by community members, but its current state is extremely basic. <a href="https://github.com/ipfs-shipyard/ipfs-ui-style-guide" target="_blank" rel="noopener noreferrer">View on GitHub</a></p>

    <h2>Nothing to see here!</h2>
    <p>This repo isn’t examined in detail because its code is primarily used as a constituent part of one or more other user-facing repos.</p>
  </div>
);

export default ReposIpfsShipyardIpfsUiStyleGuide;
